import OrganizationProfile from './OrganizationProfile.container';
export default OrganizationProfile;